import React from "react";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { NavLink } from "react-router-dom";
import { ApplicationApi, ApplicationTemplateApi } from "../../../../../../../../../../services/Api/Organization/types";
import { AppModalViewMode } from "../../../../utils/types";

interface Props {
	installedApp?: ApplicationApi;
	routeProps?: RouteComponentProps;
	configApp: ApplicationTemplateApi;
	setViewMode: React.Dispatch<React.SetStateAction<AppModalViewMode>>;
	viewMode: AppModalViewMode;
}

const AppModalBodyNav = ({ installedApp, routeProps, configApp, setViewMode, viewMode }: Props) => {
	const { t } = useTranslation();

	return (
		<Nav>
			{installedApp && routeProps ? (
				<>
					{configApp.long_description && (
						<Nav.Item onClick={() => setViewMode(AppModalViewMode.DESCRIPTION)}>
							<Nav.Link
								as={NavLink}
								to={routeProps.match.url}
								isActive={(match: Record<string, any> | null, location: Record<string, any>) =>
									viewMode === "DESCRIPTION" && !location.pathname.includes("/logs")
								}
							>
								{t("modules.app.field.app_description.title")}
							</Nav.Link>
						</Nav.Item>
					)}
					{configApp.help_description && (
						<Nav.Item onClick={() => setViewMode(AppModalViewMode.START)}>
							<Nav.Link
								as={NavLink}
								to={routeProps.match.url}
								isActive={(match: Record<string, any> | null, location: Record<string, any>) =>
									viewMode === "START" && !location.pathname.includes("/logs")
								}
							>
								{t("modules.app.field.start.title")}
							</Nav.Link>
						</Nav.Item>
					)}
				</>
			) : (
				<>
					{configApp.long_description && (
						<Nav.Item onClick={() => setViewMode(AppModalViewMode.DESCRIPTION)}>
							<Nav.Link href={"#"} active={viewMode === "DESCRIPTION"}>
								{t("modules.app.field.app_description.title")}
							</Nav.Link>
						</Nav.Item>
					)}
					{configApp.help_description && (
						<Nav.Item onClick={() => setViewMode(AppModalViewMode.START)}>
							<Nav.Link href={"#"} active={viewMode === "START"}>
								{t("modules.app.field.start.title")}
							</Nav.Link>
						</Nav.Item>
					)}
				</>
			)}
			{installedApp && routeProps && (
				<Nav.Item onClick={() => setViewMode(AppModalViewMode.FORM)}>
					<Nav.Link
						as={NavLink}
						isActive={(match: Record<string, any> | null, location: Record<string, any>) =>
							viewMode === "FORM" && !location.pathname.includes("/logs")
						}
						to={routeProps.match.url}
					>
						{t("modules.app.field.settings.title")}
					</Nav.Link>
				</Nav.Item>
			)}
		</Nav>
	);
};

export default AppModalBodyNav;
